export default __webpack_public_path__ + "static/media/badge-4.e017ce9a.png";